import { render, staticRenderFns } from "./CardPreview.vue?vue&type=template&id=31771f70"
import script from "./CardPreview.vue?vue&type=script&lang=js"
export * from "./CardPreview.vue?vue&type=script&lang=js"
import style0 from "./CardPreview.vue?vue&type=style&index=0&id=31771f70&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports